import { useNavigate } from "react-router-dom"
import { Plus } from "lucide-react"

import { PageHeader, PrimaryBtn } from "../../common/ui"
import { LOsTableWithImporter } from "../../common/ui/loan-officers"
import { RequireRole } from "../../common/validation"
import {
  useAppDispatch,
  useAppSelector,
  useIsSuperAdmin
} from "../../common/hooks"
import { setVisiblePanel } from "../../redux/slices/app"
import { selectUserDetails } from "../../redux/slices/auth"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"

const LOPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const user = useAppSelector(selectUserDetails)

  const isSuperAdmin = useIsSuperAdmin()

  const onCreate = () => dispatch(setVisiblePanel("loan-officer/new"))

  const onClickLO = (loanOfficerId: string) => {
    navigate(`/loan-officers/${loanOfficerId}`)
  }

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE["loan-officers"]}>
      <div className="p-6 bg-white">
        <div className="pb-6">
          <PageHeader title="Loan officers">
            <PrimaryBtn onClick={onCreate}>
              <Plus size={16} className="mr-1" /> New LO
            </PrimaryBtn>
          </PageHeader>
        </div>

        <LOsTableWithImporter
          searchParams={{ isSuperAdmin, org_id: user?.org?.id }}
          hasMasqueradeIcon
          onClickLO={onClickLO}
        />
      </div>
    </RequireRole>
  )
}

export default LOPage
